module.exports = import("https://cdn.skypack.dev/glitched-writer@2.0.29");;